import React from 'react';

export default function ManageBoxesIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_24901_90505)">
        <path d="M9.16667 11.4585C9.16667 11.1143 8.885 10.8335 8.54167 10.8335H5.41667V13.3335C5.41667 13.7935 5.04333 14.1668 4.58333 14.1668C4.12333 14.1668 3.75 13.7935 3.75 13.3335V10.8335H0.625C0.280833 10.8335 0 11.1143 0 11.4585V19.3752C0 19.7193 0.280833 20.0002 0.625 20.0002H8.54167C8.885 20.0002 9.16667 19.7193 9.16667 19.3752V11.4585Z" fill="#9A9AAF"/>
        <path d="M20.0007 11.4585C20.0007 11.1143 19.719 10.8335 19.3757 10.8335H16.2507V13.3335C16.2507 13.7935 15.8773 14.1668 15.4173 14.1668C14.9573 14.1668 14.584 13.7935 14.584 13.3335V10.8335H11.459C11.1148 10.8335 10.834 11.1143 10.834 11.4585V19.3752C10.834 19.7193 11.1148 20.0002 11.459 20.0002H19.3757C19.719 20.0002 20.0007 19.7193 20.0007 19.3752V11.4585Z" fill="#9A9AAF"/>
        <path d="M14.5827 0.625C14.5827 0.281667 14.301 0 13.9577 0H10.8327V2.5C10.8327 2.96 10.4593 3.33333 9.99935 3.33333C9.53935 3.33333 9.16602 2.96 9.16602 2.5V0H6.04102C5.69685 0 5.41602 0.281667 5.41602 0.625V8.54167C5.41602 8.88583 5.69685 9.16667 6.04102 9.16667H13.9577C14.301 9.16667 14.5827 8.88583 14.5827 8.54167V0.625Z" fill="#9A9AAF"/>
      </g>
      <defs>
        <clipPath id="clip0_24901_90505">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}